import { CapoPlugin } from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];